import {isString} from 'lodash';

import {StylableProps} from '../../../../lib/styleHelpers';
import {MediumIconName} from '../../../molecules/icon';

export interface HeaderMenuLinkProps {
  name: string;
  href: string;
}

export interface HeaderMenuLeftSubItemProps extends HeaderMenuLinkProps {
  iconName: MediumIconName;
  isExternal?: boolean;
  featureFlag?: HeaderMenuLeftSubItemFeatureFlag;
}

export interface HeaderMenuLeftCallToActionProps {
  title: string;
  href: string;
  linkLabel: string;
  backgroundImage: string;
}

export interface HeaderMenuLeftItemProps {
  name: string;
  href: string;
}

export function hasHref(src: any): src is HeaderMenuLeftItemProps {
  return isString(src.name) && isString(src.href) && src.name.length && src.href.length;
}

export interface HeaderMenuLeftItemWithSubMenuProps {
  name: string;
  subMenu: {
    items: Array<HeaderMenuLeftSubItemProps>;
    callToAction?: HeaderMenuLeftCallToActionProps;
    imageSrc: string;
  };
}

export interface HeaderMenuDynamicProps extends StylableProps {
  locationPath: string;
  isHighlighted?: boolean;
  hasBackgroundColorAnimation?: boolean;
  mainWrapperCss?: string;
  menuWrapperCss?: string;
  isDark?: boolean;
}

export interface HeaderMenuProps extends HeaderMenuDynamicProps {
  leftNav: Array<HeaderMenuLeftItemProps | HeaderMenuLeftItemWithSubMenuProps>;
  rightNav: Array<HeaderMenuLinkProps>;
  primaryItem: HeaderMenuLinkProps;
  secondaryItem: HeaderMenuLinkProps;
}

/** Actions to take on the sub item depending on a particular feature flag. */
export interface HeaderMenuLeftSubItemFeatureFlag {
  name: 'pre-trial-inbox-analysis-switch';
  action: 'replace';
  data: {
    name: string;
    href: string;
    iconName: MediumIconName;
  };
}
